import { mapGetters, mapMutations, mapActions} from 'vuex';
import * as moment from "moment/moment";

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                name: '',
                comment: '',
            }
        }
    },

    computed: {
        ...mapGetters({
            customerGroup: 'contacts/customerGroup',
            customerGroups: 'contacts/customerGroups',
        }),
    },
    watch:{
        customerGroup(e){
            if(e){
                this.form = e;
            }else{
                this.form = {
                    name: '',
                }
            }
        }
    },
    created() {
        this.getCustomerGroups();
    },
    methods: {
        closePopup() {
            this.$emit('closePopup')
        },
        sendChanges() {
            if(this.customerGroup){
                this.$emit('changeCustomerGroup', this.form)
            }else{
                this.$emit('sendCustomerGroup', this.form)
            }
        },
        createdDate(date){
            return moment(date).format('YYYY-MM-DD HH:mm')
        },
        ...mapActions({
            getCustomerGroups: 'contacts/getCustomerGroups',
        }),
        ...mapMutations({
            changeCustomerGroup: 'contacts/changeCustomerGroup',
        })
    },
    destroyed() {
        this.changeCustomerGroup(null);
    }
}